import { Component, OnInit } from '@angular/core';
import { JeevesOrderDetailsComponent } from 'gung-standard-jeeves';
import { first } from 'rxjs';

@Component({
  selector: 'cult-order-details',
  templateUrl: './cult-order-details.component.html',
  styleUrls: ['./cult-order-details.component.scss']
})
export class CultOrderDetailsComponent extends JeevesOrderDetailsComponent implements OnInit {
  isReturNoPrice = false;

  ngOnInit(): void {
    super.ngOnInit();
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
  }

  goToPage(url) {
    window
      .open('https://www.dhl.com/se-en/home/tracking/tracking-freight.html?submit=1&tracking-id=' + url, '_blank')
      .focus();
  }
}
